import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import CurdReducer from "./CRUDReducer";
import AuthReducer from "./Auth";
import Language from "./Language";

const rootReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    CrudR: CurdReducer,
    AuthR: AuthReducer,
    Language: Language
  });

export default rootReducer;
